import { Arrow, Content } from '@radix-ui/react-hover-card'
import styled from 'styled-components'

import type { Size, Width } from '../../../themes/types'
import {
  slideDownAndFade,
  slideLeftAndFade,
  slideRightAndFade,
  slideUpAndFade,
} from '../../../utils/styles/keyframes.styles'

export const StyledContent = styled(Content)<{ $spacing: Size; $minWidth: Width }>`
  z-index: 1000;
  border-radius: ${props => props.theme.dimensions.borderRadius};
  padding: ${props => props.theme.spacings[props.$spacing]};
  min-width: ${props => props.$minWidth};
  background-color: ${props => props.theme.colors.white.base};
  box-shadow:
    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;

  &[data-side='top'] {
    animation-name: ${slideDownAndFade};
  }
  &[data-side='right'] {
    animation-name: ${slideLeftAndFade};
  }
  &[data-side='bottom'] {
    animation-name: ${slideUpAndFade};
  }
  &[data-side='left'] {
    animation-name: ${slideRightAndFade};
  }
`

export const StyledArrow = styled(Arrow)`
  fill: ${props => props.theme.colors.white.base};
`
